import { ACTION_TYPES } from '../utils/Constants';

let initialState = {
    chatMessagesList: [],
    typingIndicator: {},
    receiverUserId: '',
    senderUserId: '',
    messages: [],
};

const ChatReducerList = (state = initialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.STUDENT.CHAT_MESSAGES_LIST:
            return {
                ...state,
                chatMessagesList: [...state.chatMessagesList, action.payload.message],
            };
        case ACTION_TYPES.STUDENT.CLEAR_CHAT_MESSAGES_LIST:
            return {
                ...state,
                chatMessagesList: [],
            };
        case ACTION_TYPES.TYPING_INDICATOR:
            return {
                ...state,
                typingIndicator: action.payload.typing,
                receiverUserId: action.payload.receiverUserId,
                senderUserId: action.payload.senderUserId,
            };
        case ACTION_TYPES.MESSAGE_READ:
            return {
                ...state,
                message_read: action.payload.message_read,
            };
        default:
            return state;
    }
};

export default ChatReducerList;
